<template>
  <div class="boostFormTable ps-table-wrap">
    <ve-table
       :fixed-header="true"
        :columns="columns"
        :max-height="'calc(100vh - 210px)'"
        :sort-option="sortOption"
      :table-data="tableData"
      :border-around="true"
    />
    <empty-state v-if="showEmptyResult" :title="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.NO_RECORDS')" />
    <div v-if="isLoading" class="call-campaign--loader">
      <spinner />
      <span>{{$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.LOADING')}}</span>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import alertMixin from 'shared/mixins/alertMixin';
// import WootButton from 'dashboard/components/ui/WootButton.vue';
import copy from 'copy-text-to-clipboard';
import ToggleField from 'components/ui/inputs/ToggleField.vue';
import responsiveMixin from 'shared/mixins/responsiveMixin.js';


export default {
    components:{
        VeTable,
        Spinner,
        EmptyState,
        ToggleField,
    },
    mixins: [alertMixin, responsiveMixin],
    props:{
        records:{
            type: Array,
            default: () => []
        },
        cols: {
            type: Array,
            default: () => [],
        },
        showEmptyResult: {
          type: Boolean,
          default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data(){
      return {
        sortConfig: {},
        sortOption: {
          sortAlways: true,
          sortIcons: {
            ascend: "top-arrow",
            descend: "bottom-arrow"
          },
          sortChange: params => this.$emit('on-sort-change', params),
        },
      }
    },
    computed: {
        tableData() {
          if (this.isLoading) {
              // return [];
          }
          return this.records;
        },
        columns(){
            let matches = {};

            matches.title = {
              field: 'title',
              key: 'title',
              title: 'Title',
              width: 280,
              align: 'left',
              renderBodyCell: ({ row }) => <div onClick={() => this.onClickTitle(row)}>
                <p class="clickableRow text_purple_primary ">{row.title}</p>
              </div>,
            };

            matches.description = {
              field: 'description',
              key: 'description',
              title: 'Description',
              width: this.isMobile ? 300: null,
            //  minWidth: 300,
              align: 'left',
              // renderBodyCell: ({ row }) => <span>{row.description}</span>,
            };
            matches.published = {
              field: 'published',
              key: 'published',
              title: 'Published',
              width: 100,
              align: 'center',
              renderBodyCell: ({ row }) => {
                return <div  onClick={()=>this.onPublish(row)}>
                <ToggleField
                  value={row.published}
                  className="mb_0"
                /></div>
              },
            };

            matches.actions = {
                field: 'actions',
                key: 'actions',
                title: 'Actions',
                fixed: this.isMobile ? false:'right',
                align: 'center',
                width: this.isMobile ? 150: 300,
                renderBodyCell: ({ row }) => (
                    <div className="actions-wrapper">
                    <woot-button
                        variant="smooth"
                        color-scheme="secondary"
                        icon="copy"
                        size="small"
                        class-names="margin-right-button"
                        onClick={() => this.copyLink(row)}
                    />
                    <woot-button
                        class="ml_4"
                        variant="smooth"
                        color-scheme="primary"
                        icon="edit"
                        class-names="margin-right-button"
                        size="small"
                        onClick={() => this.$emit("onEdit",row)}
                    />
                    <woot-button
                        class="ml_4"
                        variant="smooth"
                        color-scheme="alert"
                        icon="dismiss-circle"
                        class-names="grey-btn"
                        size="small"
                        onClick={() => this.$emit("onDelete",row)}
                    />
                    </div>
                ),
            };

            const preSet = [];
            this.cols.forEach(col=>{
              if (col.visible) {
                if (col.key in matches) {
                  preSet.push(matches[col.key])
                }
              }
            })
            return preSet;
        },
    },
    methods:{
        copyLink(item){
            copy(item.links);
            this.showAlert('Link Copied');
        },
        async onPublish(item){
          console.log(item);
           try {
              await this.$store.dispatch('campaigns/toggleCampaignFormPublish', {form_id:item.id});
              this.showAlert(this.$t('CAMPAIGN.CAMPAIGN_FORMS.TABLE.ACTIONS.PUBLISH.SUCCESS'));
            } catch (error) {
                this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
            }
        },
        onClickTitle(row){
          console.log(row);
          this.$router.push({
            name: 'campaign_form_responder_list',
            params: { campaign_form_id: row.id }
          });
        },
    },

}
</script>



<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';


.campaign--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}
.call-campaign--loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 2rem;
  font-size: 14px;
}

.actions-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

}



</style>

<style>
.ps-table-wrap .clickableRow{
  cursor: pointer;
  /* color: #8D25F6; */
}
.boostFormTable  .ve-table-body-td{
  white-space: normal !important;
}
</style>

